/* eslint-disable max-len */

const vgh = {
  beratersuche: '$t(footer.beratersuche){{PARAM}}',
  siegel: [],
  sparkasse: {
    produkt: 'Hausratversicherung',
  },
  pakete: ['Basis', 'Komfort', 'Premium'],
  summingup: {
    fahrrad: 'Fahrraddiebstahl',
    glas: 'Glasversicherung',
    natur: 'Naturgefahren',
    notfall: 'Notfalldienste',
  },
  prepage: {
    pageTitle: 'Hausratversicherung',
    headline: 'Die $t(mandant) Hausratversicherung',
    leistungen: [
      'Absicherung von Schäden an Einrichtungs- und Gebrauchsgegenständen',
      'Ersatz zum Neuwert',
      'Erstattung bei Feuer, Einbruchdiebstahl, Beraubung, Leitungswasser, Sturm, Hagel und Starkregen',
    ],
  },
  erstedaten: {
    headline: 'Hausratversicherung berechnen',
    berechnenSieInWenigenSekunden: 'Berechnen Sie in wenigen Sekunden den Beitrag für Ihren Hausrat. Los geht’s!',
    frageHabenSieBereitsHausrat: 'Haben Sie bereits eine Hausratversicherung bei der $t(mandant)?',
    frageBestehendenVertragAnpassen: 'Möchten Sie Ihren bestehenden Vertrag anpassen?',
    vsnrHausratAltFuerNeuordnung: 'Um Ihren Vertrag anzupassen, erfassen Sie bitte Ihre Vertragsnummer:',
    anschrift_tt: `<h2>Anschrift</h2>
        <p>Der Wohnort hat Auswirkungen auf den Beitrag. Darum brauchen wir die Adresse, wo der Hausrat versichert werden soll. Aber keine Angst: Wir speichern Ihre Daten erst, wenn Sie auch abschließen möchten.</p>`,
    anschrift_sub: 'Bitte geben Sie hier die Adresse ein, unter der Sie den Hausrat versichern möchten.',
    wohnflaeche_tt: `<h2>Wohnfläche</h2>
        <p>Anhand der Wohnfläche berechnen wir den Beitrag.</p>
        <p>Bitte geben Sie hier die Wohnfläche der zu versichernden Wohnung/des zu versichernden Hauses ein.</p>`,
    typ_tt: `<h2>Wohnung oder Haus?</h2>
        <p>Geben Sie hier an, ob Sie den Hausrat in einer Wohnung oder einem Haus versichern möchten.</p>
        <p>Wenn das Haus oder die Wohnung nicht dauerhaft bewohnt sind, lassen Sie sich bitte <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank" rel="noopener noreferrer">vor Ort beraten</a>.</p>`,
    gebdat_tt: `<h2>Warum fragen wir das?</h2>
        <p>Anhand Ihres Alters ermitteln wir den optimalen Tarif für Sie.</p>`,
    jung_alert: '<p>Bis {{DAT}} bekommen Sie unsere Hausratversicherung besonders günstig!</p>',
    tarifart: 'Arbeiten Sie im öffentlichen Dienst?',
    oeffdienst_tt: `<h2>Nachlass für öffentlichen Dienst</h2>
        <p>Als öffentliche-rechtliche Versicherung bieten wir Ihnen besondere Konditionen, wenn Sie im öffentlichen Dienst arbeiten.</p>`,
    versbeginn_tt: `<h2>Versicherungsbeginn</h2>
        <p>Geben Sie hier an, wann der Versicherungsschutz beginnen soll.</p>`,
    versicherbar: '<p>Im Internet versichern wir nur dauerhaft bewohnte Objekte. Ferienwohnungen'
      + ' und -häuser oder WG-Zimmer können Sie gern bei uns <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">vor Ort versichern ></a>.</p>',
    weiter: 'Preis anzeigen',
  },
  footertext: `<h2 class="h5">Beitragsberechnung zur Hausratversicherung</h2>
<p>Mit dem <strong>Beitragsrechner zur Hausratversicherung der VGH berechnen Sie in wenigen Sekunden, was die Versicherung für Ihren Hausrat kostet.</strong> 
Nach der Beantwortung weniger Fragen erfahren Sie sofort die Versicherungskosten und können direkt online abschließen.</p>
<p>Die Hausratversicherung der <strong>VGH</strong> ist die richtige Wahl für alle, die ihren "Wohnungsinhalt" oder die Einrichtung Ihres Hauses in Niedersachsen absichern wollen. 
Mit unserer langjährigen Erfahrung wissen wir, worauf es ankommt. Ihr Hausrat ist bei uns in den besten Händen. 
Mit den starken Leistungen der VGH Hausratversicherung ist Ihr Hab und Gut bestens geschützt.</p>
<p>Mit unseren Zusatzbausteinen können Sie den Versicherungsschutz individuell gestalten und zum Beispiel Schutz vor Naturgefahren (Elementarschäden) einschließen.</p>
<p>Profitieren Sie von starken Leistungen: Wir leisten bei Schäden für die Reparatur oder Neuanschaffung einschließlich Preissteigerungen und Folgekosten. 
Mit der Außenversicherung sind Ihre Sachen auf Reisen versichert. Auf Wunsch sind zudem Schäden durch grobe Fahrlässigkeit oder der Diebstahl in Schule oder am Arbeitsplatz eingeschlossen.</p>`,

  produktvergleich: {
    headline: 'Wählen Sie Ihren Schutzumfang',
    mehrleistungen: 'Mehr anzeigen',
    wenigerleistungen: 'Weniger anzeigen',
    Basis: {
      andereLeistungen: {
        vsu: 'Versicherungssumme {{VSU}}&nbsp;€',
        wertsachen: 'Wertsachen je nach Art bis zu {{WERT}}&nbsp;€',
      },
      andereLeistungenTooltips: {
        wertsachen: `<h2>Wertsachen</h2>
          <ul class="list-icn-checkbullet">
          <li>Wertsachen sind insgesamt bis zu einer Höhe von 20&nbsp;% der Versicherungssumme mitversichert.*</li>
          <li>Bargeld und auf Geldkarten geladene Beträge sind bis maximal 2.500&nbsp;€ versichert.</li>
          <li>Urkunden, Sparbücher und Wertpapiere sind bis maximal 5.000&nbsp;€ versichert.</li>
          <li>Schmucksachen, Uhren, Edelsteine, Perlen, Briefmarken, Münzen und Medaillen sowie alle Sachen aus Gold 
          oder Platin sind bis maximal 25.000&nbsp;€ versichert.</li>
          </ul>
          $t(produktvergleich.Basis.andereLeistungenTooltips.wertsachen_hinweis)
          $t(produktvergleich.Basis.andereLeistungenTooltips.wertsachen_footer)`,
        wertsachen_hinweis: '<p class="mini"><strong>* Wenn die versicherte Summe zu niedrig ist, ersetzen wir Schäden nur anteilig!</strong></p>',
        wertsachen_footer: `<p>Bitte wenden Sie sich an Ihren <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">Ansprechpartner vor Ort</a>, 
          falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>`,
      },
      leistungen: {
        neuwert: 'Neuwertversicherung',
        gefahren: 'Feuer, Einbruch und Beraubung, Vandalismus, Sturm, Hagel, Starkregen/Rückstau und Leitungswasser',
        aussen: 'Außenversicherung',
      },
      leistungenTooltips: {
        aussen: `<h2>Außenversicherung</h2>
        <p>Es besteht weltweiter Schutz für versicherte Sachen, die sich vorübergehend, längstens für 3 Monate, außerhalb des Versicherungsortes – also der Wohnung oder des Hauses – befinden. Wir erstatten bis zu 20&nbsp;% der 
        Versicherungssumme, maximal 20.000&nbsp;€.</p>`,
      },
      keineLeistungen: {
        blitz: 'Blitzüberspannung',
        fahrlaessigkeit: 'Grobe Fahrlässigkeit',
        auto: 'Diebstahl aus dem Auto bis 5.000&nbsp;€',
        garten: 'Schäden an Garteninventar bis 10.000&nbsp;€',
        arbeitsplatz: 'Diebstahl am Arbeitsplatz oder in der Schule bis 5.000&nbsp;€',
        notfall: 'Notfalldienste bis 1.000&nbsp;€',
      },
      vsu_prozentsatz: '10',
    },
    Komfort: {
      andereLeistungen: {
        vsu: 'Versicherungssumme {{VSU}}&nbsp;€',
        wertsachen: 'Wertsachen je nach Art bis zu {{WERT}}&nbsp;€',
      },
      andereLeistungenTooltips: {
        wertsachen: `<h2>Wertsachen</h2>
          <ul class="list-icn-checkbullet">
          <li>Wertsachen sind insgesamt bis zu einer Höhe von 30&nbsp;% der Versicherungssumme mitversichert.*</li>
          <li>Bargeld und auf Geldkarten geladene Beträge sind bis maximal 5.000&nbsp;€ versichert.</li>
          <li>Urkunden, Sparbücher und Wertpapiere sind bis maximal 10.000&nbsp;€ versichert.</li>
          <li>Schmucksachen, Uhren, Edelsteine, Perlen, Briefmarken, Münzen und Medaillen sowie alle Sachen aus Gold oder 
          Platin sind bis maximal 50.000&nbsp;€ versichert.</li>
          </ul>
          $t(produktvergleich.Basis.andereLeistungenTooltips.wertsachen_hinweis)
          $t(produktvergleich.Komfort.andereLeistungenTooltips.wertsachen_footer)`,
        wertsachen_hinweis: '<p class="mini"><strong>* Wenn die versicherte Summe zu niedrig ist, ersetzen wir Schäden nur anteilig!</strong></p>',
        wertsachen_footer: `<p>Bitte wenden Sie sich an Ihren <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">Ansprechpartner vor Ort</a>, 
          falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>`,
      },
      leistungen: {
        neuwert: 'Neuwertversicherung',
        gefahren: 'Feuer, Einbruch und Beraubung, Vandalismus, Sturm, Hagel, Starkregen/Rückstau und Leitungswasser',
        aussen: 'Außenversicherung',
        blitz: 'Blitzüberspannung',
        fahrlaessigkeit: 'Grobe Fahrlässigkeit bis 10.000&nbsp;€',
      },
      keineLeistungen: {
        auto: 'Diebstahl aus dem Auto bis 5.000&nbsp;€',
        garten: 'Schäden an Garteninventar bis 10.000&nbsp;€',
        arbeitsplatz: 'Diebstahl am Arbeitsplatz oder in der Schule bis 5.000&nbsp;€',
        notfall: 'Notfalldienste bis 1.000&nbsp;€',
      },
      vsu_prozentsatz: '20',
    },
    Premium: {
      andereLeistungen: {
        vsu: 'Versicherungssumme {{VSU}}&nbsp;€',
        wertsachen: 'Wertsachen je nach Art bis zu {{WERT}}&nbsp;€',
      },
      andereLeistungenTooltips: {
        wertsachen: `<h2>Wertsachen</h2>
          <ul class="list-icn-checkbullet">
          <li>Wertsachen sind insgesamt bis zu einer Höhe von 40&nbsp;% der Versicherungssumme mitversichert.*</li>
          <li>Bargeld und auf Geldkarten geladene Beträge sind bis maximal 5.000&nbsp;€ versichert.</li>
          <li>Urkunden, Sparbücher und Wertpapiere sind bis maximal 10.000&nbsp;€ versichert.</li>
          <li>Schmucksachen, Uhren, Edelsteine, Perlen, Briefmarken, Münzen und Medaillen sowie alle Sachen aus Gold oder Platin sind bis maximal 50.000&nbsp;€ versichert.</li>
          </ul>
          $t(produktvergleich.Basis.andereLeistungenTooltips.wertsachen_hinweis)
          $t(produktvergleich.Premium.andereLeistungenTooltips.wertsachen_footer)`,
        wertsachen_hinweis: '<p class="mini"><strong>* Wenn die versicherte Summe zu niedrig ist, ersetzen wir Schäden nur anteilig!</strong></p>',
        wertsachen_footer: `<p>Bitte wenden Sie sich an Ihren <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">Ansprechpartner vor Ort</a>, 
          falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>`,
      },
      leistungen: {
        neuwert: 'Neuwertversicherung',
        gefahren: 'Feuer, Einbruch und Beraubung, Vandalismus, Sturm, Hagel, Starkregen/Rückstau und Leitungswasser',
        aussen: 'Außenversicherung',
        blitz: 'Blitzüberspannung',
        fahrlaessigkeit: 'Grobe Fahrlässigkeit bis {{VSU}}&nbsp;€',
        auto: 'Diebstahl aus dem Auto bis 5.000&nbsp;€',
        garten: 'Schäden an Garteninventar bis 10.000&nbsp;€',
        arbeitsplatz: 'Diebstahl am Arbeitsplatz oder in der Schule bis 5.000&nbsp;€',
        notfall: 'Notfalldienste bis 1.000&nbsp;€',
      },
      vsu_prozentsatz: '30',
    },
    produkte: {
      vsu_flaeche: '750',
      vsu: `<h4>Versicherungssumme</h4>
        <p>Wir erstatten Hausratschäden bis zur Höhe der Versicherungssumme – zuzüglich {{VSU_PROZENTSATZ}}&nbsp;% Vorsorge und mitversicherte Kosten.</p>
        <p>So berechnet sich die Versicherungssumme:</p>
        <p class="strong">Wohnfläche in m² x $t(produktvergleich.produkte.vsu_flaeche)&nbsp;€</p>
        $t(produktvergleich.produkte.vsu_berater)
        <p>Die richtige Versicherungssumme entspricht dem Neuwert des gesamten Hausrats. Wenn die Versiche&shy;rungs&shy;summe kleiner als der Neuwert ist, spricht man von Unterversicherung. In diesem Fall wird Ihnen jeder Schaden nur anteilig ersetzt werden.</p>
        <p>Beträgt die Versicherungssumme mindestens $t(produktvergleich.produkte.vsu_flaeche)&nbsp;€ je&nbsp;m², verzichten wir auf die Prüfung der Unterversicherung.</p>`,
      vsu_berater: `<h4>Summe zu hoch oder zu niedrig?</h4>
        <p>Sollte der Hausrat mehr oder weniger wert sein, als die berechnete Summe, <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">sprechen Sie uns an ></a></p>`,
      feuer: `<h4>Feuer</h4>
        <p>Versichert sind Hausratschäden durch Feuer (Brand, Blitzschlag, Explosion, Implosion, Verpuffung, Rauch und Ruß, Schwel-, Schmor- und Sengschäden, anprall von Fahrzeugen).</p>
        <p>In der Basisdeckung sind nur Brand, Blitzschlag, Explosion und Anprall von Luftfahrzeugen versichert.</p>`,
      einbruch: `<h4>Einbruchdiebstahl und Beraubung</h4>
        <p>Einbruchdiebstahl liegt vor, wenn der Dieb in Ihre Wohnung oder Haus eindringt und Ihre Sachen entwendet. Bei Beraubung wendet der Dieb sogar noch körperliche Gewalt an.</p>
        <p>Unter Hausrat versteht man den Inhalt Ihrer Wohnung oder Ihres Hauses. Zu ihm zählen Einrichtungsgegenstände, Gebrauchsgegenstände wie Kleidung, aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen.</p>
        <p><strong>Ihr Plus:</strong> Zusätzlich sind Gebäudeschäden durch Einbruch abgedeckt – zum Beispiel, wenn Einbrecher Fenster oder Türen aufhebeln.</p>`,
      vandalismus: `<h4>Vandalismus nach einem Einbruch</h4>
        <p>Versichert sind Schäden durch Vandalismus nach einem Einbruch – zum Beispiel, wenn Einbrecher die Wohnung verwüsten.</p>
        <p>Unter Hausrat versteht man den Inhalt der Wohnung oder des Hauses. Zu ihm zählen Einrichtungs&shy;gegen&shy;stände, Gebrauchs&shy;gegenstände wie Kleidung, aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen.</p>`,
      sturm: `<h4>Sturm, Hagel und Leitungswasser</h4>
        <p>Versichert sind Hausratschäden durch Sturm, Hagel und Leitungswasser – zum Beispiel, wenn nach einem Rohrbuch Ihr Haus unter Wasser steht.</p>
        <p>Unter Hausrat versteht man den Inhalt der Wohnung oder des Hauses. Zu ihm zählen Einrichtungs&shy;gegen&shy;stände, Gebrauchs&shy;gegenstände wie Kleidung, aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen.</p>`,
      aussen: `<h4>Außenversicherung</h4>
        <p>Es besteht weltweiter Schutz für versicherte Sachen, die sich vorübergehend, längstens für 6 Monate, außerhalb des Versicherungsortes – also der Wohnung oder des Hauses – befinden. Wir erstatten bis zu 
        30&nbsp;% der Versicherungssumme, maximal 30.000&nbsp;€.</p>`,
      regen: `<h4>Schäden durch Starkregen und -rückstau</h4>
        <p>Bei einer Überschwemmung durch Starkregen wird das Gelände, auf dem sich das Haus oder die Wohnung befindet, durch Witterungsniederschläge überflutet: Wassermassen dringen in das Gebäude oder die Wohnung ein.</p>
        <p>Schäden durch Rückstau können entstehen, wenn zum Beispiel nach starken Regenfällen die Kanalisation die Wassermassen nicht mehr aufnehmen kann und das Abwasser in das Haus oder die Wohnung zurückfließt.</p>`,
      blitz: `<h4>Blitzüberspannung</h4>
        <p>Blitz&shy;überspannungs&shy;schäden sind Schäden an elektrischen Einrichtungen und Geräten, die entstehen, wenn sich die erhöhte Spannung eines Blitzes über das Leitungs&shy;system bis in das eigene Haus oder die eigene Wohnung fortsetzt.</p>`,
      fahrlaessigkeit: `<h4>Grobe Fahrlässigkeit</h4>
        <p>Sie genießen auch dann noch Versicherungsschutz, wenn Sie den Schaden unachtsam selbst verursacht haben.</p>
        <p>In der Basisdeckung ist grobe Fahrlässigkeit nicht mitversichert. Im Paket Komfort ist die Entschädigung auf maximal 10.000&nbsp;€ begrenzt.</p>`,
      auto: `<h4>Diebstahl aus dem verschlossenen Kfz</h4>
        <p>Diebstahl von Hausrat aus dem verschlossenen Kfz, Wohnmobil, Wohnwagen, geschlossenen Kraftfahrzeuganhänger oder aus Dachgepäckboxen beziehungsweise Motorradkoffern sowie Wassersportfahrzeugen ist 
        innerhalb Europas (im geografischen Sinn) bis 5.000&nbsp;€ versichert.</p>`,
      garten: `<h4>Schäden an Gartenmöbeln und -inventar</h4>
        <p>Schäden durch Diebstahl, Feuer, Sturm und Hagel an Gartenmöbeln und Garteninventar sind bis 10.000&nbsp;€ versichert.</p>
        <p>Zum Inventar zählen zum Beispiel Rasenmähroboter, Grills, Balkonkraftwerke, Gartendekoration, Kinderspielzeug und Pool- und Grundwasserpumpen sowie Wäsche und Bekleidung.</p>`,
      arbeitsplatz: `<h4>Diebstahl am Arbeitsplatz oder in der Schule</h4>
        <p>Mitversichert ist der Diebstahl von versicherten Sachen (zum Beispiel Handtasche oder Portemonnaie) am Arbeitsplatz oder in der Universität sowie von Lernmitteln und Bekleidung von Kindern in der Schule, im Kindergarten oder im Hort.</p>
        <p>Die Entschädigung ist je Versicherungsfall auf 5.000&nbsp;€ und maximal 500&nbsp;€ für Bargeld begrenzt.</p>`,
      notfall: `<h4>Notfalldienste</h4>
        <p>Ihre Heizung ist kalt, Sie haben den Schlüssel verloren oder ein Bienenvolk hat sich auf Ihrem Balkon eingenistet? Kleine Ärgernisse kosten viel Zeit, Geld und Nerven. Kosten für Notdienst- und Handwerkerleistungen 
        bei einem Notfall sind abgedeckt.</p>
        <p>Je Versicherungsfall erstatten wir bis zu 1.000&nbsp;€ und maximal 3.000&nbsp;€ für alle Versicherungsfälle im Versicherungsjahr (Versicherungsperiode).</p>`,
      neuwert: `<h4>Neuwertversicherung</h4>
        <p>Wir ersetzen Ihren Hausrat zum Neuwert, wenn die beschädigten oder zerstörten Sachen nicht repariert werden können. Dabei spielt der ursprüngliche Anschaffungspreis keine Rolle. 
        Sie erhalten im Schadenfall immer den Betrag, der zur Wiederbeschaffung oder Reparatur "in gleicher Art und Güte" notwendig ist. Und sollte nach einer Reparatur eine Wertminderung bleiben, 
        gleichen wir diese ebenfalls aus.</p>
        <p>Unter Hausrat versteht man den Inhalt der Wohnung oder des Hauses. Zu ihm zählen Einrichtungs&shy;gegen&shy;stände, Gebrauchsgegenstände wie Kleidung, aber auch Verbrauchsgüter (z. B. Essen) und Wertsachen.</p>`,
      hagel: `<h4>Hagel</h4>
        <p>Versichert sind Schäden an Ihrem Hausrat durch Hagel.</p>
        <p>Unter Hausrat versteht man den Inhalt Ihrer Wohnung oder Ihres Hauses. Zu ihm zählen Einrichtungsgegenstände, Gebrauchsgegenstände wie Kleidung, aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen.</p>`,
      gefahren: `
        <h4>Versicherte Gefahren</h4>
        <p>Versichert sind Schäden an Ihrem Hausrat unter anderem durch Feuer (Brand, Blitzschlag und Explosion), 
        Einbruchdiebstahl und Beraubung, Vandalismus nach einem Einbruch und bei Beraubung, Sturm und Hagel, Starkregen/Rückstau und Leitungswasser.</p>`,
    },
    sb_tt: `<h2>Selbstbeteiligung Hausratversicherung</h2>
      <p>Wenn Sie eine Selbstbeteiligung (SB) vereinbaren, müssen Sie im Schadenfall einen Teil der Kosten selbst bezahlen – aber nur bis zur Höhe der vereinbarten SB.</p>
      <p>Je höher die SB, desto geringer ist Ihr Beitrag.</p>
      <p>Die hier ausgewählte SB gilt nur für die Hausratversicherung.</p>
      <p>Für die Glasversicherung und die Fahrraddiebstahl-Versicherung gelten keine Selbstbeteiligungen.</p>`,
    laufzeit_tt: `<h2>Vertragslaufzeit</h2>
      <p>Bei Abschluss eines 3-Jahresvertrages bekommen Sie 10&nbsp;% Nachlass auf Ihren Beitrag.</p>
      <p>Nach Ablauf der gewünschten Laufzeit verlängert sich Ihr Vertrag automatisch um ein Jahr. Sollten Sie kündigen wollen, muss das drei Monate vor Vertrags&shy;ablauf erfolgen.</p>`,
    laufzeit_alert: '<p>Wenn das Beschäftigungsverhältnis "Verbund" ausgewählt ist, darf die'
      + ' Vertragslaufzeit 1 Jahr nicht überschreiten.</p>',
    zahlweise_tt: '<h2>Zahlweise</h2><p>Wenn Sie jährlich zahlen, profitieren Sie von einem Beitragsvorteil.</p>',
    links: {
      leistungsuebersichtLink: 'https://www.vgh.de/hausrat_leistungsuebersicht',
      leistungsuebersicht: '<a target="_blank" rel="noopener noreferrer" data-tracking-name="link-leistungsuebersicht" href="$t(produktvergleich.links.leistungsuebersichtLink)">Leistungsübersicht ></a>',
      infoBlattLink: 'https://www.vgh.de/hausrat_produktinformation',
      infoBlatt: '<a target="_blank" rel="noopener noreferrer"'
        + ' data-tracking-name="link-infoblatt-hausrat"'
        + ' href="$t(produktvergleich.links.infoBlattLink)">Informationsblatt zur'
        + ' Hausratversicherung</a>',
      infoBlattGlasLink: 'https://www.vgh.de/haushalt_glas_produktinformation',
      infoBlattGlas: '<a target="_blank" rel="noopener noreferrer"'
        + ' data-tracking-name="link-infoblatt-glas"'
        + ' href="$t(produktvergleich.links.infoBlattGlasLink)">Informationsblatt zur'
        + ' Haushalt-Glasversicherung</a>',
      versBedingungenLink: 'https://www.vgh.de/hausrat_versicherungsbedingungen',
      versBedingungen: '<a target="_blank" rel="noopener noreferrer"'
        + ' data-tracking-name="link-versicherungsbedingungen" href="$t(produktvergleich.links.versBedingungenLink)">Hausrat-Versicherungs&shy;bedingungen</a>',
      versBedingungenGlasLink: 'https://www.vgh.de/haushalt_glas_versicherungsbedingungen',
      versBedingungenGlas: '<a target="_blank" rel="noopener noreferrer"'
        + ' data-tracking-name="link-versicherungsbedingungen-glas"'
        + ' href="$t(produktvergleich.links.versBedingungenGlasLink)">Haushalt-Glas-Versicherungs&shy;bedingungen</a>',
    },
    zusatz: {
      naturgefahren_beschreibung: '<p>Wasserdichter Schutz bei weiteren Naturgefahren (Elementar&shy;schäden) wie zum'
        + ' Beispiel Hoch&shy;wasser.</p>',
      naturgefahren_tt: `<h2>Schutz vor weiteren Naturgefahren (Elementarschäden)</h2>
        <p>Naturgefahren gehören leider fast schon zur Tagesordnung – auch in unseren Breitengraden. Dabei machen 
        Hochwasser oder Schnee vor Ihrer Türschwelle nicht halt. Mit dem Zusatzbaustein weitere Naturgefahren (Elementarschäden) erhalten Sie wetterfesten Schutz vom Keller bis zum Dach vor...</p>
        <ul class="list-icn-checkbullet">
          <li>Überschwemmungen durch Flüsse, Bäche und Seen inklusive Rückstau</li>
          <li>Erdbeben und Vulkanausbruch</li>
          <li>Erdfall und Erdrutsch</li>
          <li>Schneedruck und Lawinen</li>
        </ul>`,
      naturgefahren_alert_nichtVerfuegbar: '<p>Den Schutz vor Naturgefahren gibt\'s nur in den Paketen $t(pakete.1) und $t(pakete.2).</p>',
      naturgefahren_alert_gk0: '<p>Wir empfehlen Ihnen die Absicherung gegen weitere Naturgefahren (Elementarschäden). Für Ihre Adresse '
        + 'können wir den Preis jedoch nicht exakt bestimmen. Hier ist eine persönliche Beratung notwendig. Bitte wenden Sie sich an '
        + 'Ihren Ansprechpartner <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">vor Ort</a>.</p>',
      naturgefahren_alert_gk4: '<p>Wir empfehlen Ihnen die Absicherung gegen weitere Naturgefahren (Elementarschäden). Ihre Adresse '
        + 'befindet sich jedoch in einem Risikogebiet. Hier ist eine persönliche Beratung notwendig. Bitte wenden Sie sich an '
        + 'Ihren Ansprechpartner <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">vor Ort</a>.</p>',
      naturgefahren_alert_gk0_if: '<p>Wir empfehlen Ihnen die Absicherung gegen weitere Naturgefahren (Elementarschäden). Für Ihre Adresse '
        + 'können wir den Preis jedoch nicht exakt bestimmen. Hier ist eine persönliche Beratung notwendig. Bitte wenden Sie sich an Ihren Sparkassenberater vor Ort. </p>',
      naturgefahren_alert_gk4_if: '<p>Wir empfehlen Ihnen die Absicherung gegen weitere Naturgefahren (Elementarschäden). Ihre Adresse befindet sich jedoch in einem '
        + 'Risikogebiet. Hier ist eine persönliche Beratung notwendig. Bitte wenden Sie sich an Ihren Sparkassenberater vor Ort.</p>',
      naturgefahren_alert_gk0_stat: '<p>Für Ihre Adresse können wir den Preis der Versicherung gegen weitere Naturgefahren (Elementarschäden) '
        + 'nicht exakt bestimmen. Falls dieser Schutz gewünscht ist, kann es sein, dass der Beitrag höher oder niedriger ausfällt. '
        + 'Hier erfolgt eine gesonderte Prüfung durch den Innendienst. Bitte wenden Sie sich zwecks einer genauen Preisberechnung inklusive '
        + 'Schutz vor weiteren Naturgefahren (Elementarschäden) an Ihre Versicherungsfachabteilung.</p>',
      naturgefahren_alert_gk4_stat: '<p>Ihre Adresse befindet sich in einem Risikogebiet. Bei Einschluss der Versicherung gegen weitere '
        + 'Naturgefahren (Elementarschäden) erfolgt eine gesonderte Prüfung durch den Innendienst.</p>',
      naturgefahren_sb_label: 'Selbstbeteiligung für Überschwemmung',
      naturgefahren_sb_tt: `<h2>Selbstbeteiligung für erweiterte Naturgefahren (Elementarschäden) durch Überschwemmung</h2>
      <p>Wenn Sie eine höhere Selbstbeteiligung (SB) für Überschwemmung vereinbaren, müssen Sie im Schadenfall einen Teil der Kosten selbst bezahlen –
        aber nur bis zur Höhe der vereinbarten SB.</p>
      <p>Je höher die SB, desto geringer ist Ihr Beitrag.</p>
      <p><strong>Hinweis:</strong> Die hier ausgewählte SB gilt nur für Schäden durch Überschwemmung.</p>`,
      glasversicherung_beschreibung: 'Wir zahlen, wenn’s klirrt – und zwar unabhängig von der Ursache.',
      glasversicherung_alert_neuordnung_hausrat: 'Im Neuordnungsprozess für die Hausratversicherung kann die Glasversicherung nicht abgeschlossen werden.',
      glasversicherung_alert_neuordnung_hausrat_medial: 'Im Neuordnungsprozess für die Hausratversicherung kann die Glasversicherung nicht abgeschlossen werden. Bitte wenden Sie sich an Ihren Sparkassenberater vor Ort.',
      glasversicherung_alert_neuordnung_haushaltglas: 'Im Neuordnungsprozess für die Haushaltglasversicherung kann die Glasversicherung nicht abgewählt werden.',
      glasversicherung_tt: `<h2>Glasversicherung</h2>
        <p>Wir ersetzen Glasbruchschäden – und zwar unabhängig von der Schadenursache. Versichern können Sie:</p>
        <ul class="list-icn-checkbullet">
          <li>Mobiliarverglasung – zum Beispiel, wenn Sie einen schweren Topf auf das Induktionsfeld fallen lassen und dieses springt.</li>
          <li>Mobiliar- und Gebäudeverglasung – zum Beispiel, wenn ein Kind mit dem Fußball Ihr Fenster zerschießt.</li>
        </ul>`,
      fahrraddiebstahl_title: 'Fahrraddiebstahl einschließen',
      fahrraddiebstahl_beschreibung: 'Mit diesem Baustein sind Ihre Fahrräder bei Diebstahl'
        + ' versichert, überall und rund um die Uhr.',
      fahrraddiebstahl_tt: `<h2>Schutzbaustein Fahrraddiebstahl</h2>
        <p>Sie lieben Ihr Fahrrad? Mit dem Zusatzbaustein Fahrraddiebstahl genießen Sie Diebstahlschutz zum günstigen Pauschalpreis für alle Fahrräder, E-Bikes* und Fahrradanhänger in Ihrem Haushalt:</p>
        <ul class="list-icn-checkbullet">
          <li>zu jeder Tages- und Nachtzeit</li>
          <li>an jedem Ort</li>
          <li>Erstattung zum vollen Neuwert</li>
        </ul>
        <p><strong>*Bitte beachten Sie:</strong> Kennzeichenpflichtige E-Bikes (Fahrräder mit E-Motor) sind nicht mitversichert.</p>`,
    },
  },
  personendaten: {
    anschrift_tt: `<h2>Anschrift</h2>
    <p>Der Hausrat wird an der hier genannten Adresse versichert.</p>
    <ul class="list-icn-checkbullet">
      <li><strong>Sie möchten den Hausrat an einer anderen Adresse versichern?</strong> Dann nutzen Sie bitte den Link "Anschrift ändern".</li>
      <li><strong>Sie möchten die Hausratversicherung für jemand anderen abschließen?</strong> Dann geben Sie auf dieser Seite bitte Ihre eigene Adresse an.</li>
    </ul>
    $t(personendaten.anschrift_tt_subtext)`,
    anschrift_tt_subtext: '<p>Bitte beachten Sie, dass wir im Internet nur dauerhaft bewohnte'
      + ' Objekte versichern. <strong>Ferienwohnungen und -häuser</strong> versichern wir gerne <a'
      + ' data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">vor Ort</a>.</p>',
  },
  vorversicherung: {
    vsnr_label: 'Falls vorhanden: Wie lautet die Versicherungsscheinnummer?',
    hausratschaeden_tt: `<h2>Hausratschäden</h2>
      <p>Das sind Schäden an Ihrem "Wohnungsinhalt" durch Feuer, Leitungswasser, Sturm, Hagel, Starkregen oder Diebstahl, Einbruchdiebstahl, Beraubung und Vandalismus.</p>
      <p>Bitte geben Sie auch Schäden an, die nicht versichert waren oder die nicht ersetzt wurden.</p>`,
    naturschaeden_tt: `<h2>Schäden aus Naturgefahren (Elementarschäden)</h2>
      <p>Das sind Schäden an Ihrem "Wohnungsinhalt" zum Beispiel durch Hochwasser, Erdrutsch oder Lawinen.</p>
      <p>Bitte geben Sie auch Schäden an, die nicht versichert waren oder die nicht ersetzt wurden.</p>`,
    glasschaeden_tt: `<h2>Glasbruchschäden</h2>
      <p>Das sind Schäden an Ihrer Mobiliar- oder Gebäudeverglasung – zum Beispiel Glastische, Ceran-Kochfelder, Duschabtrennungen oder Fenster.</p>
      <p>Wenn Sie nur Mobiliarverglasung versichern möchten, müssen Sie natürlich auch nur Schäden an Mobiliarverglasungen angeben.</p>
      <p>Bitte geben Sie auch Schäden an, die nicht versichert waren oder die nicht ersetzt wurden.</p>`,
    rueckstausicherung_tt: `<h2>Was ist eine Rückstausicherung?</h2>
      <p>Rückstausicherungen verhindern, dass Abwasser durch Rohrleitungen zurück in das Haus fließt. Das kann zum Beispiel passieren, wenn die Kanalisation durch Starkregen oder Hochwasser "überläuft".</p>`,
    nichtversicherbar: `<p>Leider können wir Sie nicht im Internet versichern. Wenden Sie sich bitte an Ihren 
       <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">Ansprechpartner vor Ort ></a>
    </p>`,
  },
  zahlungsdaten: {
    headline: 'Ihre Daten sind bei uns so sicher, wie Ihr $t(fahrzeug)!',
    zahlart_alert: 'Auf Grund des gewählten Verbundtarifes, ist die Zahlung per Rechnung nicht möglich.',
    datenschutzLink: 'Ihre Daten leiten wir an den ausgewählten Ansprechpartner weiter. Details hierzu finden Sie in unseren <a target="_blank" rel="noopener noreferrer"'
      + ' data-tracking-name="link-datenschutz-info"'
      + ' href=$t(footer.datenschutz)>Information zum Datenschutz</a>.',
    datenschutzAnfang: 'Wir nutzen Ihre Daten im Rahmen unserer $t(datenschutz.link) und der'
      + ' <a target="_blank" rel="noopener noreferrer" data-tracking-name="link-kfzbedingungen"'
      + ' href=$t(zusammenfassung.kfz_bedingungen)>Versicherungs&shy;bedigungen'
      + ' (Auskünfte über den Schadenverlauf)</a> unter anderem zu folgenden'
      + ' Zwecken:',
  },
  zusammenfassung: {
    weiter: 'Weiter',
  },
  beantragen: {
    headline: 'Fast geschafft!',
    downloadinhalt: `<h4>Mit Klick auf die Fläche laden Sie folgende Dokumente herunter:</h4>
      <ul class="list-icn-checkbullet">
        <li>Antrag</li>
        <li>Mitteilung nach § 19 Abs. 5 VVG</li>
        <li>Infos zum Datenschutz, zum Hinweis- und Informations&shy;system sowie zur Bonitätsprüfung</li>
        <li>Informations&shy;blatt zur Hausratversicherung (IPID)/Glasversicherung (IPID)</li>
        <li>Leistungsübersicht</li>
        <li>Vertrags&shy;informationen (VVG-InfoV)</li>
        <li>Versicherungsbedingungen Hausrat/Glas</li>
      </ul>`,
    warenkorb: {
      naturgefahren: 'Schutz vor Naturgefahren',
      notfalldienst: 'Schutzbaustein Notfalldienste',
    },
    captcha_tt: `<h2>Wir bitten Sie um Ihre Hilfe:</h2>
      <p>
      Mit diesem Captcha verhindern wir Spam durch Robots und schützen unsere Systeme vor Schadprogrammen.
      </p>
      <p>
      Bitte beachten Sie bei der Eingabe die Groß-/Kleinschreibung.</p>`,
  },
  abschluss: {
    headline: 'Herzlich willkommen bei der $t(mandant)!',
    ersterAbsatz: 'Vielen Dank für Ihr Vertrauen! Wir freuen uns, dass Sie sich für unsere'
      + ' Hausratversicherung entschieden haben. Sobald Ihr Antrag bei uns eingegangen ist, senden wir Ihnen per E-Mail eine Bestätigung. Eine Unterschrift ist nicht mehr notwendig.',
    fragen: 'Sie haben Fragen? Gerne hilft Ihnen auch unser Vertragsservice unter der'
      + ' Telefonnummer $t(abschluss.telefon).',
  },
};

export default vgh;
